import { ContactsComponent } from './../components/contacts/contacts.component';
import { FileDetailComponent } from './../components/files/file-detail.component';
import { FileBrowseComponent } from './../shared/components/browse/file-browse.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';
import { AuthGuard } from './../shared/guards/auth.guard';
import { EntityBrowseComponent } from '../shared/components/browse/entity-browse.component';
import { OfficeContactDetailComponent } from '../components/contacts/office-contact-detail.component';
import { OfficeDetailComponent } from '../components/contacts/office-detail.component';
import { SponsoredDetailComponent } from '../components/contacts/sponsored-detail.component';
import { PartnerDetailComponent } from '../components/contacts/partner-detail.component';

export const contactRoutes = {
  path: 'contacts',
  data: {
    breadcrumbs: {
      label: 'Kontakty',
      icon: 'newsletter'
    },
    state: 'contacts'
  },
  children: [
    {
      path: '',
      component: ContactsComponent
    },
    {
      path: 'office-contacts/add',
      data: {
        breadcrumbs: {
          label: 'Přidat kontaktní osobu'
        },
        state: 'office-contact-add'
      },
      children: [
        {
          path: '',
          component: OfficeContactDetailComponent
        },
        {
          path: 'file/:id',
          component: FileDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Upravit soubor'
            },
            state: 'office-contacts-media-edit'
          },
          outlet: 'modal'
        },
        {
          path: 'files',
          component: FileBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat soubor'
            },
            state: 'office-contacts-media-browse',
            isSingle: true,
            imgOnly: true
          },
          outlet: 'browse'
        },
        {
          path: 'entities/:url/:single',
          component: EntityBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat'
            },
            state: 'office-contacts-entities-browse'
          },
          outlet: 'browse'
        },
        {
          path: 'offices',
          component: OfficeDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Přidat kategorii'
            },
            state: 'office-modal-edit'
          },
          outlet: 'modal-form'
        }
      ]
    },
    {
      path: 'office-contacts/edit/:id',
      data: {
        breadcrumbs: {
          label: 'Upravit osobu'
        },
        state: 'office-contact-edit'
      },
      children: [
        {
          path: '',
          component: OfficeContactDetailComponent
        },
        {
          path: 'file/:id',
          component: FileDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Upravit soubor'
            },
            state: 'office-contacts-media-edit'
          },
          outlet: 'modal'
        },
        {
          path: 'files',
          component: FileBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat soubor'
            },
            state: 'office-contacts-media-browse',
            isSingle: true,
            imgOnly: true
          },
          outlet: 'browse'
        },
        {
          path: 'entities/:url/:single',
          component: EntityBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat'
            },
            state: 'office-contacts-entities-browse'
          },
          outlet: 'browse'
        },
        {
          path: 'offices',
          component: OfficeDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Přidat kategorii'
            },
            state: 'office-modal-edit'
          },
          outlet: 'modal-form'
        }
      ]
    },
    {
      path: 'offices/add',
      data: {
        breadcrumbs: {
          label: 'Přidat kategorii osob'
        },
        state: 'office-contact-add'
      },
      children: [
        {
          path: '',
          component: OfficeDetailComponent
        },
        {
          path: 'file/:id',
          component: FileDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Upravit soubor'
            },
            state: 'offices-media-edit'
          },
          outlet: 'modal'
        },
        {
          path: 'files',
          component: FileBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat soubor'
            },
            state: 'offices-media-browse',
            isSingle: true,
            imgOnly: true
          },
          outlet: 'browse'
        },
        {
          path: 'entities/:url/:single',
          component: EntityBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat'
            },
            state: 'offices-entities-browse'
          },
          outlet: 'browse'
        },
        {
          path: 'office-contacts',
          component: OfficeContactDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Přidat osobu'
            },
            state: 'office-contacts-modal-edit'
          },
          outlet: 'modal-form'
        }
      ]
    },
    {
      path: 'offices/edit/:id',
      data: {
        breadcrumbs: {
          label: 'Upravit kategorii osob'
        },
        state: 'office-contact-edit'
      },
      children: [
        {
          path: '',
          component: OfficeDetailComponent
        },
        {
          path: 'file/:id',
          component: FileDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Upravit soubor'
            },
            state: 'offices-media-edit'
          },
          outlet: 'modal'
        },
        {
          path: 'files',
          component: FileBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat soubor'
            },
            state: 'offices-media-browse',
            isSingle: true,
            imgOnly: true
          },
          outlet: 'browse'
        },
        {
          path: 'entities/:url/:single',
          component: EntityBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat'
            },
            state: 'offices-entities-browse'
          },
          outlet: 'browse'
        },
        {
          path: 'office-contacts',
          component: OfficeContactDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Přidat osobu'
            },
            state: 'office-contacts-modal-edit'
          },
          outlet: 'modal-form'
        }
      ]
    },
    {
      path: 'offices-delete/:id',
      component: ConfirmationComponent,
      data: {
        breadcrumbs: {
          label: 'Smazat kategorii osob'
        },
        state: 'office-contact-category-delete',
        apiUri: 'offices'
      },
      outlet: 'modal'
    },
    {
      path: 'office-contacts-delete/:id',
      component: ConfirmationComponent,
      data: {
        breadcrumbs: {
          label: 'Smazat kontaktní osobu'
        },
        state: 'office-contact-delete',
        apiUri: 'office-contacts'
      },
      outlet: 'modal'
    },
    {
      path: 'contacts-delete/:id',
      component: ConfirmationComponent,
      data: {
        breadcrumbs: {
          label: 'Smazat kontakt'
        },
        state: 'contact-delete',
        apiUri: 'contacts'
      },
      outlet: 'modal'
    },
    {
      path: 'sponsored/add',
      data: {
        breadcrumbs: {
          label: 'Přidat sponzorovaného'
        },
        state: 'sponsored-add'
      },
      children: [
        {
          path: '',
          component: SponsoredDetailComponent
        },
        {
          path: 'file/:id',
          component: FileDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Upravit soubor'
            },
            state: 'sponsored-media-edit'
          },
          outlet: 'modal'
        },
        {
          path: 'files',
          component: FileBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat soubor'
            },
            state: 'sponsored-media-browse',
            isSingle: true,
            imgOnly: true
          },
          outlet: 'browse'
        },
        {
          path: 'entities/:url/:single',
          component: EntityBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat'
            },
            state: 'sponsored-entities-browse'
          },
          outlet: 'browse'
        }
      ]
    },
    {
      path: 'sponsored/edit/:id',
      data: {
        breadcrumbs: {
          label: 'Upravit sponzorovaného'
        },
        state: 'sponsored-edit'
      },
      children: [
        {
          path: '',
          component: SponsoredDetailComponent
        },
        {
          path: 'file/:id',
          component: FileDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Upravit soubor'
            },
            state: 'sponsored-media-edit'
          },
          outlet: 'modal'
        },
        {
          path: 'files',
          component: FileBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat soubor'
            },
            state: 'sponsored-media-browse',
            isSingle: true,
            imgOnly: true
          },
          outlet: 'browse'
        },
        {
          path: 'entities/:url/:single',
          component: EntityBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat'
            },
            state: 'sponsored-entities-browse'
          },
          outlet: 'browse'
        }
      ]
    },
    {
      path: 'sponsored-delete/:id',
      component: ConfirmationComponent,
      data: {
        breadcrumbs: {
          label: 'Smazat sponzorovaného'
        },
        state: 'sponsored-delete',
        apiUri: 'sponsored'
      },
      outlet: 'modal'
    },
    {
      path: 'partners/add',
      data: {
        breadcrumbs: {
          label: 'Přidat partnera'
        },
        state: 'partners-add'
      },
      children: [
        {
          path: '',
          component: PartnerDetailComponent
        },
        {
          path: 'file/:id',
          component: FileDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Upravit soubor'
            },
            state: 'partners-media-edit'
          },
          outlet: 'modal'
        },
        {
          path: 'files',
          component: FileBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat soubor'
            },
            state: 'partners-media-browse',
            isSingle: true,
            imgOnly: true
          },
          outlet: 'browse'
        },
        {
          path: 'entities/:url/:single',
          component: EntityBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat'
            },
            state: 'partners-entities-browse'
          },
          outlet: 'browse'
        }
      ]
    },
    {
      path: 'partners/edit/:id',
      data: {
        breadcrumbs: {
          label: 'Upravit partnera'
        },
        state: 'partners-edit'
      },
      children: [
        {
          path: '',
          component: PartnerDetailComponent
        },
        {
          path: 'file/:id',
          component: FileDetailComponent,
          data: {
            breadcrumbs: {
              label: 'Upravit soubor'
            },
            state: 'partners-media-edit'
          },
          outlet: 'modal'
        },
        {
          path: 'files',
          component: FileBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat soubor'
            },
            state: 'partners-media-browse',
            isSingle: true,
            imgOnly: true
          },
          outlet: 'browse'
        },
        {
          path: 'entities/:url/:single',
          component: EntityBrowseComponent,
          data: {
            breadcrumbs: {
              label: 'Vybrat'
            },
            state: 'partners-entities-browse'
          },
          outlet: 'browse'
        }
      ]
    },
    {
      path: 'partners-delete/:id',
      component: ConfirmationComponent,
      data: {
        breadcrumbs: {
          label: 'Smazat partnera'
        },
        state: 'partners-delete',
        apiUri: 'partners'
      },
      outlet: 'modal'
    },
  ],
  canActivate: [AuthGuard]
};
